import EmptyState from "layout/molecules/EmptyState";
import Filters from "layout/molecules/Filters";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { selectCompanyInfo } from "store/companySlice";
import { selectCurrentBoardData } from "store/currentBoardSlice";
import { fetchReleases, selectAllReleases } from "store/releasesSlice";

import Api from "api/Api";
import MainContainer from "layout/atoms/MainContainer";

import Button from "layout/atoms/Button";
import Dropdown from "layout/atoms/Dropdown";
import GridBoard from "layout/atoms/GridBoard";
import Icon from "layout/atoms/Icon";
import Label from "layout/atoms/Label";
import ReleaseCard from "layout/organisms/ReleaseCard";
import { openModal } from "store/modalsSlice";

import { ReactComponent as PlusSquareSVG } from "assets/icons/plus-square.svg";

function BoardReleases() {
  const dispatch = useDispatch();
  const { boardId } = useParams();
  const companyInfo = useSelector(selectCompanyInfo);
  const currentBoardData = useSelector(selectCurrentBoardData);
  const releases = useSelector(selectAllReleases);
  const releaseStatus = useSelector((state) => state.releases.status);
  const [filterName, setFilterName] = useState("ALL");
  const [sortName, setSortName] = useState("DATE");
  const error = useSelector((state) => state.releases.error);

  const api = new Api();
  const { t } = useTranslation();

  useEffect(() => {
    if (releaseStatus === "idle" && boardId) {
      dispatch(fetchReleases(boardId));
    }
  }, [releaseStatus, boardId, dispatch]);

  const filters = [
    { trans: "statuses.ALL", value: "ALL" },
    { trans: "boardsDetails.releaseCard.published", value: "published" },
    { trans: "boardsDetails.releaseCard.unpublished", value: "unpublished" },
  ];

  let releasesToMap = {
    ALL: releases,
    published: releases.filter((release) => release.isPublished === true),
    unpublished: releases.filter((release) => release.isPublished === false),
  };

  return (
    <MainContainer
      topbar={
        <>
          <div>
            <div>
              <h2>{t("boardsDetails.releases.header")}</h2>
            </div>
            <div>
              <Button
                size="lg"
                color="primary"
                onClick={() => dispatch(openModal({ name: "addReleaseModal" }))}
              >
                <Icon src={PlusSquareSVG} />
                <p>{t("boardsDetails.forms.addRelease.header")}</p>
              </Button>
            </div>
          </div>
          <Filters
            filters={
              <Dropdown
                placement="bottom-start"
                trigger={
                  <strong>
                    {t(
                      `${
                        filterName !== "ALL"
                          ? `boardsDetails.releaseCard.${filterName}`
                          : "statuses.ALL"
                      }`,
                    )}{" "}
                    &#9662;
                  </strong>
                }
              >
                {filters.map((item) => (
                  <Label
                    key={item.value}
                    size="s"
                    status={item.value}
                    onClick={() => setFilterName(item.value)}
                  >
                    {t(`${item.trans}`)}
                  </Label>
                ))}
              </Dropdown>
            }
            sorts={<strong>{t(`sorts.${sortName}`)}</strong>}
          />
        </>
      }
      topbarWithBottomBar
    >
      <GridBoard>
        {releasesToMap[filterName].length !== 0 ? (
          releasesToMap[filterName].map((item) => (
            <ReleaseCard
              key={item.id}
              releaseId={item.id}
              boardId={boardId}
              name={item.name}
              releaseDate={item.releaseDate}
            />
          ))
        ) : (
          <EmptyState
            type="noReleases"
            header={t("emptyStates.releases.header")}
            subheader={t("emptyStates.releases.subheader")}
          />
        )}
      </GridBoard>
    </MainContainer>
  );
}

export default BoardReleases;
